import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AuthenticationService } from '../services';
import { TranslateService } from '@ngx-translate/core';
import { KeycloakService } from 'keycloak-angular';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly toastService: ToastrService,
    private readonly translate: TranslateService,
    private readonly router: Router,
    private readonly keycloak: KeycloakService
  ) {}

  private errorGenericActions(errorMessage, error) {
    if(error){
      let message = {
        code: error.status,
        message: ''
      };
      if(typeof error.error === 'string'){
        message = JSON.parse(error.error);
      } else {
        message = error.error;
      }
      errorMessage = `${message.code}: ${message.message}`;
      if(!this.toastService.findDuplicate(errorMessage, true, false)){
        this.toastService.error(errorMessage);
      }
    } else {
      this.toastService.error(this.translate.instant('genericErrorMessages.unexpectedError'));
    }
  }

  private loginAuthErrorActions(error) {
    localStorage.clear();
    sessionStorage.clear();
    this.keycloak.logout(window.location.origin);
  }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((response: any) => {
        const body = response.body;
        if (body && body.inError) {
          throw new HttpErrorResponse({
            status: body.responseCode,
            statusText: body.message,
            url: response.url,
          });
        }
      }),catchError((error: HttpErrorResponse) => {
        
        let errorMessage = '';
        
        if (error.status === 498 || error.status === 401) {
          this.loginAuthErrorActions(error);
        } 
        else if (error.status === 404) {
          this.errorGenericActions(errorMessage, error);
        } 
        else if (error.error instanceof ErrorEvent) {
          errorMessage = error.error.message;
          this.toastService.error(errorMessage);
        } 
        else {
          this.errorGenericActions(errorMessage, error);
        }
        return throwError(error);
      })
    );
  }
}
